import ApplePayIcon from '@/components/atoms/icons/Checkout/ApplePay.vue';
import BankIcon from '@/components/atoms/icons/Checkout/Bank.vue';
import CardIcon from '@/components/atoms/icons/Checkout/Card.vue';
import GooglePayIcon from '@/components/atoms/icons/Checkout/GooglePay.vue';
import IrisIcon from '@/components/atoms/icons/Checkout/Iris.vue';
import KlarnaIcon from '@/components/atoms/icons/Checkout/Klarna.vue';

const PaymentMethods = Object.freeze({
    CARD: 'card',
    IRIS: 'iris',
    APPLE_PAY: 'apple_pay',
    GOOGLE_PAY: 'google_pay',
    BANK_TRANSFER: 'bank_transfer',
    KLARNA: 'klarna',
});

const vivaPaymentMethods = [
    PaymentMethods.CARD,
    PaymentMethods.IRIS,
    PaymentMethods.APPLE_PAY,
    PaymentMethods.GOOGLE_PAY,
    PaymentMethods.KLARNA,
];

const paymentOptions = [
    {
        icon: CardIcon,
        value: { method: PaymentMethods.CARD, id: 0 },
        label: 'Πιστωτική/Χρεωστική Κάρτα',
        sublabel: 'έως και 12 άτοκες δόσεις με την πιστωτική σου κάρτα',
    },
    {
        icon: ApplePayIcon,
        value: { method: PaymentMethods.APPLE_PAY, id: 20 },
        label: 'Apple Pay',
    },
    {
        icon: GooglePayIcon,
        value: { method: PaymentMethods.GOOGLE_PAY, id: 21 },
        label: 'Google Pay',
    },
    {
        icon: IrisIcon,
        value: { method: PaymentMethods.IRIS, id: 29 },
        label: 'Άμεση Μεταφορά Χρημάτων',
    },
    {
        icon: BankIcon,
        value: { method: PaymentMethods.BANK_TRANSFER },
        label: 'Πληρωμή σε Τραπεζικό Λογαριασμό',
    },
    {
        icon: KlarnaIcon,
        value: { method: PaymentMethods.KLARNA, id: 26 },
        label: 'ΝΕΟΣ Τρόπος Πληρωμής',
        sublabel: '3 άτοκες δόσεις με τη χρεωστική σου κάρτα!',
    },
];

export { PaymentMethods, paymentOptions, vivaPaymentMethods };

